import { api } from './authService';

const planPilotService = {
  getDepartments: async () => {
    const response = await api.get('/expert/planpilot/departments');
    return response.data;
  },
  getLearners: async () => {
    const response = await api.get('/expert/planpilot/learners');
    return response.data;
  }
};

export default planPilotService;
